export default __webpack_public_path__ + "static/media/in-love.ff8891cd.png";